<template>

    <div class="animated fadeIn">

        <b-row class="py-2">

            <b-card header="Nuevo Proyecto Asociado" class="w-100">

                <associated-project-form
                    class="px-3"
                    :renderDeleteButton="false"
                    :renderSaveButton="mixinCheckPermission('ASSOCIATED_PROJECT_NEW')"
                    @save-associated-project="addAssociatedProject($event)">
                </associated-project-form>

            </b-card>

        </b-row>

    </div>

</template>

<script>

    import AssociatedProjectForm from './AssociatedProjectForm';
    import {createAssociatedProject} from '@/api/associated-project-api';

    export default {
        name: "AddAssociatedProject",
        components: {AssociatedProjectForm},
        comments: {
            AssociatedProjectForm
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/admin/associated-projects/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
            };
        },

        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
        },

        methods: {

            addAssociatedProject(associatedProject) {

                this.$_loadingMixin_showLoading();

                createAssociatedProject(associatedProject)
                    .then(() => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_success('Operación Completada', 'Proyecto asociado creado con éxito');
                        this.$router.push({path: '/admin/associated-projects/list'});
                    })
                    .catch(() => {
                        this.$_loadingMixin_hideLoading();
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    });
            }
        }
    }
</script>